import React, { useEffect, useState } from "react";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setPanchangUpdateReducer } from "../redux/slice/panchangUpdate";

export default function TodayPanchang({ show, onHide }) {
  const dispatch = useDispatch();

  const [panchangData, setpanchangData] = useState([]);
  const deliveryDate = useSelector((state) => state.deliveryDate.value);
  const [getPanchangDate, setPanchangDate] = useState(new Date());
  const [getPrevSector, setPrevSector] = useState();
  const [getCurrentSector, setCurrentSector] = useState();
  const [getNextSector, setNextSector] = useState();

  // const [value, setPanchangDate] = useState(new Date());

  const handleNext = () => {
    const nextDate = new Date(getPanchangDate);
    nextDate.setDate(nextDate.getDate() + 1);
    setPanchangDate(nextDate);
  };

  const handlePrev = () => {
    const prevDate = new Date(getPanchangDate);
    prevDate.setDate(prevDate.getDate() - 1);
    setPanchangDate(prevDate);
  };

  const handleRefresh = () => {
    const now = new Date();
    setPanchangDate(now);
    // console.log("Refresh clicked:", now);
  };

  const handlePanchangHide = () => {
    onHide();
  };

  useEffect(() => {
    // const delivery = moment(deliveryDate, "YYYY-MM-DD", true); // strict parse
    // console.log("Date:- ", delivery)
    // if (delivery.isValid() && delivery.isBefore(moment(), "day")) {
    //   const delivery = new Date(deliveryDate); // deliveryDate can be string or Date
    //   const now = new Date();
    //   delivery.setHours(
    //     now.getHours(),
    //     now.getMinutes(),
    //     now.getSeconds(),
    //     now.getMilliseconds()
    //   );
    //   setPanchangDate(delivery);
    // } else {
      setPanchangDate(new Date());
    // }
  }, [deliveryDate]);

  useEffect(() => {
    if (window.calculate && getPanchangDate) {
      // console.log("getPanchangDate", getPanchangDate);
      if (moment().isSame(getPanchangDate, "day")) {
        window.calculate("");
      } else {
        window.calculate(moment(getPanchangDate).toDate());
      }

      let panchang = JSON.parse(localStorage.getItem("panchang"));
      setpanchangData(panchang);
    }
  }, [getPanchangDate]);

  useEffect(() => {
    if (panchangData) {
      const start = moment(
        panchangData.Nakshatra_time?.split("to")[0],
        "DD-MM-YYYY HH:mm"
      );
      const end = moment(
        panchangData.Nakshatra_time?.split("to")[1],
        "DD-MM-YYYY HH:mm"
      );

      if (moment().isBetween(start, end, null, "[]")) {
        // console.log("YYYYY");
        dispatch(setPanchangUpdateReducer(panchangData));
        setPrevSector(panchangData.CurrentNakshatraSector);
        setCurrentSector(panchangData.NextNakshatraSector);
        setNextSector(panchangData.NextNakshatraSector2);
      } else {
        // console.log("nnnnn");
        dispatch(setPanchangUpdateReducer(panchangData));
        setPrevSector(panchangData.PastNakshatraSector);
        setCurrentSector(panchangData.CurrentNakshatraSector);
        setNextSector(panchangData.NextNakshatraSector);
      }
    }
  }, [panchangData]);

  return (
    <div
      className="panchag_wrap"
      style={{ display: show === true ? "block" : "none" }}
    >
      <table>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "middle" }}>
              <a
                href="https://www.drikpanchang.com/planet/position/planetary-positions-sidereal.html"
                target="_blank"
              >
                Date &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                {moment(getPanchangDate).format("ddd")}
              </a>
            </td>
            <td>
              <div style={{ display: "flex", gap: 0, alignItems: "center" }}>
                <button type="button" onClick={handlePrev}>
                  ◀
                </button>
                {/* <DatePicker 
                                  placeholderText={'Select date'}
                                  selected={getPanchangDate} 
                                  onChange={(d) => setPanchangDate(d)}
                                  dateFormat="dd-MM-YYYY"
                              /> */}

                <DateTimePicker
                  format="dd/MM/yyyy HH:mm:ss"
                  onChange={setPanchangDate}
                  value={getPanchangDate}
                  disableClock={true}
                  clearIcon={null}
                  className="datepicer_custom"
                />
                <button type="button" onClick={handleNext}>
                  ▶
                </button>
                <div onClick={handlePanchangHide} className="close_panc"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <a
                href="https://www.timeanddate.com/moon/phases/india/mumbai"
                target="_blank"
              >
                Moon
              </a>
            </td>
            <td>
              {panchangData.Moon} - [{panchangData.Tara}]<br />
              {panchangData.Nakshatra_time}
            </td>
          </tr>
          <tr>
            <td>Moon Phase</td>
            <td
              style={{
                background: panchangData.Vedha?.vedha
                  ? "#f00"
                  : panchangData.Vedha?.phaseName?.match(
                      /Full Moon|New Moon|First Quarter|Third Quarter/
                    )
                  ? "#ff8787"
                  : "#FFF",
              }}
            >
              {panchangData.Vedha?.deg}° | {panchangData.Vedha?.message}{" "}
            </td>
          </tr>

          <tr>
            <td style={{ background: "#ffd1d1" }}>Prev Sectors</td>
            <td>{getPrevSector?.toString().replace(/,[s]*/g, ", ")}</td>
          </tr>
          <tr>
            <td style={{ background: "#d0ffd2" }}>Curr Sectors</td>
            <td>{getCurrentSector?.toString().replace(/,[s]*/g, ", ")}</td>
          </tr>
          <tr>
            <td style={{ background: "#fff6c8" }}>Next Sectors</td>
            <td>{getNextSector?.toString().replace(/,[s]*/g, ", ")}</td>
          </tr>

          <tr>
            <td>Sun</td>
            <td>{panchangData.Sun}</td>
          </tr>
          <tr>
            <td>Mercury</td>
            <td>{panchangData.Mercury}</td>
          </tr>
          <tr>
            <td>Mars</td>
            <td>{panchangData.Mars}</td>
          </tr>
          <tr>
            <td>Venus</td>
            <td>{panchangData.Venus}</td>
          </tr>
          <tr>
            <td>Tithi</td>
            <td>{panchangData.Tithi}</td>
          </tr>
          <tr>
            <td>Vaar</td>
            <td>{panchangData.Vaar}</td>
          </tr>
          <tr>
            <td>Yoga</td>
            <td>
              {panchangData.Yoga} <br />
              {panchangData.Yoga_time}
            </td>
          </tr>
          <tr>
            <td>Karana</td>
            <td>
              {panchangData.Karana}
              <br />
              {panchangData.Karana_time}
            </td>
          </tr>
          <tr>
            <td>Rahu kaal</td>
            <td>{panchangData.Rahukaal}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
